import { render, staticRenderFns } from "./update-password-dialog.vue?vue&type=template&id=765e7f2c&scoped=true"
import script from "./update-password-dialog.vue?vue&type=script&lang=js"
export * from "./update-password-dialog.vue?vue&type=script&lang=js"
import style0 from "./update-password-dialog.vue?vue&type=style&index=0&id=765e7f2c&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "765e7f2c",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("C:\\Users\\mrzhj\\Desktop\\ff\\frontent\\takeout\\www\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('765e7f2c')) {
      api.createRecord('765e7f2c', component.options)
    } else {
      api.reload('765e7f2c', component.options)
    }
    module.hot.accept("./update-password-dialog.vue?vue&type=template&id=765e7f2c&scoped=true", function () {
      api.rerender('765e7f2c', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/login/update-password-dialog.vue"
export default component.exports